import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINT } from './endpoints';
import { tSendEmailRequest } from 'app/types/send-email-request.type';
import { tTemplateSettingRequest, tTemplateType } from 'app/types/template-setting.type';
import { TemplateModel } from 'app/models/settings/template.model';
import { tTooltipRequest } from 'app/types/tooltip.type';
import { TooltipModel } from 'app/models/shared/tooltip.model';
import { EmailLogModel } from 'app/models/settings/email-log.model';
import { ActivityEventModel } from 'app/models/shared/activity-event.model';

@Injectable({providedIn: 'root'})
export class SettingsService {
    constructor(private apiService: ApiService) {

    }

    sendEmail(body: tSendEmailRequest) {
        return  this.apiService.post(`${API_ENDPOINT.Email}/send-matching-report`, body);
    };
    
    saveTemplate(id: string | undefined, body: tTemplateSettingRequest) {
        if (id)
            return this.apiService.update<string>(`${API_ENDPOINT.Setting}/template/${id}`, body);
        else {
            return this.apiService.post<string>(`${API_ENDPOINT.Setting}/template`, body);
        }
    };
    
    getTemplates() {
      return this.apiService.get<TemplateModel[]>(`${API_ENDPOINT.Setting}/template`);
    };
    
    
    getTemplate(type: tTemplateType) {
        return this.apiService.get<TemplateModel[]>(`${API_ENDPOINT.Setting}/template?type=${type}`);
    };

    getTooltips() {
        return this.apiService.get<TooltipModel[]>(`${API_ENDPOINT.Setting}/tooltips`);
    }

    saveTooltip(body: tTooltipRequest) {
        return this.apiService.post<TooltipModel>(`${API_ENDPOINT.Setting}/tooltip`, body);
    };

    getVendorEmail(vendorId: string) {
        return this.apiService.get<string>(`${API_ENDPOINT.Vendor}/${vendorId}/email`);
    }

    saveVendorEmail(vendorId: string, email: string) {
        return this.apiService.update<void>(`${API_ENDPOINT.Vendor}/${vendorId}/email`, { email });
    }

    getEmailLogs(matchingId: string) {
        return this.apiService.get<EmailLogModel[]>(`${API_ENDPOINT.Email}/logs?matching_id=${matchingId}`);
    }

    getMatchingActivity(matchingId: string) {
        return this.apiService.get<ActivityEventModel[]>(`${API_ENDPOINT.Matching}/${matchingId}/activity`);
    }

    getCompanyUniqueEmail() {
        return this.apiService.get<{ email: string | null }>(`${API_ENDPOINT.Email}/inbound/company/unique-email`);
    }

    generateCompanyInboundEmail() {
        return this.apiService.post<{ email: string }>(`${API_ENDPOINT.Email}/inbound/generate-email`, {});
    }
}
